import announcementText from './announcementText';
import gusto from './gusto';
import navBar from './navBar';
import onboarding from './onboarding';
import payroll from './payroll';
import progress from './progress';
import quickSearch from './quickSearch';
import scheduling from './scheduling';
import subscriptions from './subscriptionEvents';
import timesheets from './timesheets';
import companyNavigationMenu from './companyNavMenu';
import dashboard from './dashboard';
import safety from './safety';
import verification from './verification';
import more from './more';
import managementLists from './managementLists';
import webAppSwitcher from './webAppSwitcher';

const AnalyticsEvent = {
  gusto,
  navBar,
  onboarding,
  payroll,
  progress,
  quickSearch,
  scheduling,
  timesheets,
  announcementText,
  subscriptions,
  companyNavigationMenu,
  dashboard,
  safety,
  verification,
  more,
  managementLists,
  webAppSwitcher,
};

export default AnalyticsEvent;
